import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  ref: "root",
  class: "deadline-picker large-calendar"
}
const _hoisted_2 = {
  key: 0,
  class: "deadline-calendar-popover"
}
const _hoisted_3 = { class: "deadline-weekdays" }
const _hoisted_4 = { class: "deadline-calendar-grid" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "deadline-time-row"
}
const _hoisted_7 = { class: "deadline-presets" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["deadline-date-trigger", {empty:!$props.modelValue}]),
      onClick: $setup.toggle
    }, [
      _cache[7] || (_cache[7] = _createElementVNode("span", null, "📅", -1 /* CACHED */)),
      _createElementVNode("strong", null, _toDisplayString($setup.preview), 1 /* TEXT */),
      _cache[8] || (_cache[8] = _createElementVNode("span", null, "⌄", -1 /* CACHED */))
    ], 2 /* CLASS */),
    ($setup.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("header", null, [
            _createElementVNode("button", {
              type: "button",
              "aria-label": "Предыдущий месяц",
              onClick: _cache[0] || (_cache[0] = $event => ($setup.changeMonth(-1)))
            }, "‹"),
            _createElementVNode("strong", null, _toDisplayString($setup.monthTitle), 1 /* TEXT */),
            _createElementVNode("button", {
              type: "button",
              "aria-label": "Следующий месяц",
              onClick: _cache[1] || (_cache[1] = $event => ($setup.changeMonth(1)))
            }, "›")
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Пн','Вт','Ср','Чт','Пт','Сб','Вс'], (item) => {
              return _createElementVNode("span", { key: item }, _toDisplayString(item), 1 /* TEXT */)
            }), 64 /* STABLE_FRAGMENT */))
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.calendarDays, (item) => {
              return (_openBlock(), _createElementBlock("span", {
                key: item.key
              }, [
                (!item.empty)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: _normalizeClass({today:item.today,selected:item.selected}),
                      onClick: $event => ($setup.chooseDay(item.value))
                    }, _toDisplayString(item.day), 11 /* TEXT, CLASS, PROPS */, _hoisted_5))
                  : _createCommentVNode("v-if", true)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($props.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("label", null, [
            _cache[9] || (_cache[9] = _createTextVNode("Время", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.time) = $event)),
              type: "time",
              step: "900"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.time]
            ])
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("small", null, "При выборе даты устанавливается 12:00", -1 /* CACHED */))
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[3] || (_cache[3] = $event => ($setup.preset(0)))
      }, "Сегодня, 12:00"),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[4] || (_cache[4] = $event => ($setup.preset(1)))
      }, "Завтра, 12:00"),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[5] || (_cache[5] = $event => ($setup.preset(7)))
      }, "Через неделю"),
      ($props.modelValue)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "danger",
            onClick: _cache[6] || (_cache[6] = $event => (_ctx.$emit('update:modelValue','')))
          }, "Очистить"))
        : _createCommentVNode("v-if", true)
    ])
  ], 512 /* NEED_PATCH */))
}